import { useMemo } from "react";
import { matchPath, useLocation, useParams } from "react-router-dom";

import { ENav } from "components/Layout/types";
import {
  buSlugParam,
  comSlugParam,
  corpSlugParam,
  routePaths,
} from "routes/constants";

export const useGetMainPathType = () => {
  const params = useParams();
  const location = useLocation();

  const entityType = useMemo(() => {
    if (
      params[comSlugParam] ||
      matchPath(
        { path: routePaths.root.com.root.root, end: true },
        location.pathname
      )
    ) {
      return ENav.COMMUNITY;
    }

    if (
      params[buSlugParam] ||
      matchPath(
        { path: routePaths.root.bu.root.root, end: true },
        location.pathname
      )
    ) {
      return ENav.BUSINESS_UNIT;
    }

    if (
      params[corpSlugParam] ||
      matchPath(
        { path: routePaths.root.corp.root.root, end: true },
        location.pathname
      )
    ) {
      return ENav.CORPORATION;
    }

    const splitedPaths = location.pathname.split("/");

    if (splitedPaths?.[1] === ENav.SEARCH.toLowerCase()) {
      return ENav.SEARCH;
    }

    if (splitedPaths?.[1] === ENav.KENSAKU_KUN.toLowerCase()) {
      return ENav.KENSAKU_KUN;
    }

    return ENav.PERSONAL;
  }, [location.pathname, params]);

  return entityType;
};
